import { hideBlackScreen } from "common/htmlComponents/blackScreen";
import { MAXIMUM_WIDTH } from "first-animation/screen";
export async function run(context) {
    const { grey, title, sound, shade, backgroundPlayer, root, pixiContext, backgroundPersonAnimator, backgroundPerson, } = context;
    title.sprite.alpha = 0;
    shade.sprite.visible = true;
    grey.sprite.alpha = 0.5;
    hideBlackScreen();
    backgroundPersonAnimator.moveToBottom();
    sound.awaitPlay("opening").then(() => {
        backgroundPlayer.play();
    });
    await pixiContext.animate({
        start: -MAXIMUM_WIDTH,
        destination: 0,
        durationMS: 500,
        setter: (value) => {
            root.position.set(value, 0);
        },
    });
    title.sprite.alpha = 1;
    title.sprite.play();
    backgroundPerson.leftSprite.visible = true;
    backgroundPerson.leftSprite.play();
    backgroundPerson.rightSprite.visible = true;
    backgroundPerson.rightSprite.play();
    backgroundPersonAnimator.animateBeginning();
    backgroundPersonAnimator.followGoal();
    await pixiContext.delay(3000);
    sound.play("announcement1");
    await Promise.all([
        pixiContext.animate({
            start: 0.5,
            destination: 0,
            durationMS: 1000,
            setter: (value) => {
                grey.sprite.alpha = value;
            },
        }),
        pixiContext.animate({
            start: 1,
            destination: 0,
            durationMS: 500,
            setter: (value) => {
                title.sprite.alpha = value;
            },
        }),
    ]);
    title.sprite.destroy();
}
//# sourceMappingURL=video2Interaction.js.map